import { render, staticRenderFns } from "./ReportCollection.vue?vue&type=template&id=0178fe05"
import script from "./ReportCollection.vue?vue&type=script&lang=js"
export * from "./ReportCollection.vue?vue&type=script&lang=js"
import style0 from "./ReportCollection.vue?vue&type=style&index=0&id=0178fe05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports